module.exports = __webpack_public_path__ + "static/glow-a8672d4b2016b218280e8e8781df8fa5.png";